export const CTAtexts = {
  title: "Download SnapShelf Today!",
  subtitle:
    "Create your first list, and see what books you’ve been missing. It only takes a minute! ",
};
